import { BODY_COPY } from "../../utils/content-keys";

const getModuleContents = (module, contents, transform, moduleKey) =>
  contents
    .filter(
      field => module.split("|").indexOf(Object.keys(field)[0].trim()) > -1
    )
    .map(
      item =>
        transform
          ? setFieldKeys(
              getModuleDetails(item[module], !transform, moduleKey).fields
            )
          : getModuleDetails(item[module], !transform, moduleKey).fields
    );

const getModuleDetails = (fields, isNav, moduleKey) => {
  let itemIndex = 0;

  fields.some((field, index) => {
    itemIndex = index;
    return (
      field.title ===
      (field.type === "Matrix" && isNav ? "NAVIGATION" : moduleKey)
    );
  });

  return fields[itemIndex];
};

const setFieldKeys = fields =>
  fields.reduce((total, current) => {
    if (!current.title) {
      return total;
    }

    total[current.title] = current;
    return total;
  }, {});

const sortFilterFields = (contents, pageName, startIndex) => {
  let sortedContent = [];

  contents.slice(startIndex, contents.length).forEach(contentItem => {
    let moduleName = "";
    const samePage = contentItem.fields.some(
      field => field.title === "PAGE NAME" && field.value === pageName
    );

    contentItem.fields.some(field => {
      if (field.title === "MODULE") {
        moduleName = field.value;
      }

      return field.title === "MODULE";
    });

    if (samePage) {
      sortedContent.push({ [moduleName]: contentItem.fields });
    }

    return samePage;
  });

  return sortedContent;
};

const sortFilters = contents => {
  const final = {};

  contents.forEach((content, index) =>
    content.fields.forEach(
      field =>
        field.title === "PAGE NAME" && !final[field.value]
          ? (final[field.value] = sortFilterFields(
              contents,
              field.value,
              index
            ))
          : null
    )
  );

  return final;
};

const getFiltersMeta = contents => {
  const metaData = {};

  contents.some(content =>
    content.fields.some(field => {
      if (field.title === "MetaData") {
        metaData.title = field.fields[0].value;
        metaData.description = field.fields[1].value;
      }

      return field.title === "MetaData";
    })
  );

  return metaData;
};

export default (
  modules,
  contents,
  transform = true,
  moduleKey = "MODULE DETAILS"
) => {
  const filterContents = sortFilters(contents);
  let finalContents = {};

  modules.forEach(module => {
    Object.keys(filterContents).forEach(filter => {
      if (!finalContents[filter]) {
        finalContents[filter] = {};
      }

      finalContents[filter][module.title] = getModuleContents(
        module.name,
        filterContents[filter],
        transform,
        moduleKey
      );
    });
  });

  finalContents.order = Object.keys(finalContents).sort((a, b) => {
    if (!finalContents[a].Order.length || !finalContents[b].Order.length) {
      return null;
    }

    if (
      +finalContents[a].Order[0][BODY_COPY].value >
      +finalContents[b].Order[0][BODY_COPY].value
    ) {
      return 1;
    } else {
      return -1;
    }
  });

  finalContents.meta = getFiltersMeta(contents);
  return finalContents;
};



// WEBPACK FOOTER //
// ./src/pages/beers/build-filters-json.js